import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useFormContext, useWatch } from 'react-hook-form';

import AddButton from '@/modules/AdminTools/components/AddButton';
import { useGroupPlanName } from '../../NameContext';
import { productsSelector } from '@/modules/AdminTools/redux/productManager/products';
import { useEffect } from 'react';

const AddService = ({ append }) => {
  const products = useSelector(productsSelector);

  const groupPlanName = useGroupPlanName();

  let addonName = 'addons';

  let servicesName = 'service_product_ids';
  if (groupPlanName) {
    addonName = `${groupPlanName}.${addonName}`;
    servicesName = `${groupPlanName}.${servicesName}`;
  }
  const addons = useWatch({ name: addonName });
  const services = useWatch({ name: servicesName }) ?? [];
  const { setValue } = useFormContext();

  useEffect(() => {
    if (addons === undefined) {
      setValue(addonName, []);
    }
  }, [addonName, addons, setValue]);

  const length = addons?.length + services?.length;

  if (!products) {
    return null;
  }

  return (
    <AddButton onClick={append} shouldShow={products.products.length > length}>
      Add additional service
    </AddButton>
  );
};

AddService.propTypes = {
  append: PropTypes.func.isRequired,
};

export default AddService;
